import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";
import i18n from "i18next";

import { Modal } from "../Common";
import { receiveError, receiveLogin, setAccessToken, setUser, setUserMetadata } from "../../actions";
import { setIsAuthenticated, setUserMetadataFetched } from "./../../actions/appActions";
import Auth from "../../helpers/Authentication/Auth";
import loading from "./loading.svg";

class Callback extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    transition: PropTypes.object
  };

  state = {
    errorDescription: "",
    isErrorModalVisible: false
  };

  componentDidMount() {
    new Auth().handleAuthentication(this.authSuccess, this.authError);
  }

  authSuccess = () => {
    const accessToken = Auth.getAccessToken();
    const user = Auth.getUser();
    const auth = new Auth(accessToken);

    this.props.dispatch(receiveLogin(user));
    this.props.dispatch(setIsAuthenticated(true));

    this.props.dispatch(setAccessToken(accessToken));
    this.props.dispatch(setUser(user));
    auth.getUserMetadata(user.sub, (err, userInfos) => {
      if (userInfos) {
        const filteredUserInfos = _.omit(userInfos, ["user_metadata", "identities"]);
        const userData = { ...user, ...filteredUserInfos };
        this.props.dispatch(setUser(userData));

        if (userInfos.user_metadata) {
          this.props.dispatch(setUserMetadata(userInfos.user_metadata));
        }
      }

      this.props.dispatch(setUserMetadataFetched());
    });

    const lastRequestedState = Auth.popLastRequestedState();
    if (lastRequestedState && lastRequestedState.to.name !== "noRoles") {
      this.props.transition.router.stateService.go(lastRequestedState.to.name, lastRequestedState.params);
    } else {
      this.props.transition.router.stateService.go("home");
    }
  };

  authError = error => {
    this.props.dispatch(receiveError(error));
    let { errorDescription } = error;

    if (errorDescription.includes("`state` does not match.")) {
      errorDescription = i18n.t("error.authenticationFailed");
    }

    this.setState({ isErrorModalVisible: true, errorDescription });
  };

  handleCloseErrorModal = () => {
    this.props.transition.router.stateService.go("logout");
  };

  errorButtons = [
    {
      onClose: this.handleCloseErrorModal,
      label: "OK"
    }
  ];

  render() {
    const style = {
      position: "absolute",
      display: "flex",
      justifyContent: "center",
      height: "100vh",
      width: "100vw",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "white"
    };

    return (
      <Fragment>
        {!this.state.isErrorModalVisible && (
          <div style={style}>
            <img src={loading} alt="loading" />
          </div>
        )}
        {this.state.isErrorModalVisible && <Modal buttons={this.errorButtons} className="--error" title={this.state.errorDescription} />}
      </Fragment>
    );
  }
}

export default connect()(Callback);



// WEBPACK FOOTER //
// ./src/components/Callback/Callback.js